import { useMemo } from 'react';

import type { IntegrationProviderCategory } from '@/api/integration';
import { useCurrentInstance } from '@/api/organization';
import { C99_INSTANCE_PATTERN } from '@/constants';

const useDenyConnectionCreation = (category: IntegrationProviderCategory) => {
  const { instance } = useCurrentInstance();

  return useMemo(() => {
    if (C99_INSTANCE_PATTERN.test(instance?.id ?? '')) {
      return false;
    }
    return category === 'crm' && instance?.hasActiveCRMConnection;
  }, [instance?.id, category, instance?.hasActiveCRMConnection]);
};

export default useDenyConnectionCreation;
